import React, { useState, useRef, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { insertNewUser } from "../../app/redux/slices/signupSlice";
import { routePath as RP } from "../../app/components/router/routepath";
import { useNavigate } from "react-router-dom";
import "../../pages/styles.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Swal from "sweetalert2";
import { uploadFormFilesReq } from "../../api/scholarshipapplication/scholarshipapplication";
import { ApiKey } from "../../api/endpoint";
import { publicAxios } from "../../api/config";
import { fetchCoursesByClassReq } from "../../api/Scholarship/SponsorScholarship";
import CreatableSelect from "react-select/creatable";

export default function SignUpPage() {
  const [step, setStep] = useState(0);
  const [userType, setUserType] = useState("student"); // default to student
  const [showPassword, setShowPassword] = useState(false);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [specializationList, setSpecializationList] = useState([]);
const shouldShowYear = ![1, 2, 3].includes(Number(selectedClassId));
  const fileInputRef = useRef(null);
  const [basicDetails, setBasicDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    fatherOccupation: "",
    motherOccupation: "",
    address: "",
    parentContactNumber: "",
    familyIncome: "",
    stateId: "",
    countryId: "",
    documents: [],
  });

  const [educationList, setEducationList] = useState([]);
  const [eduErrors, setEduErrors] = useState({});
  const [education, setEducation] = useState({ degree: "", specification: "", college: "", year: "" });
  const [showEducationFields, setShowEducationFields] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [verification, setVerification] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  const [years, setYears] = useState([]);
const [loadingYears, setLoadingYears] = useState(false);
useEffect(() => {
  if ([1, 2, 3].includes(Number(selectedClassId))) {
    setEducation(prev => ({ ...prev, year: "" }));
  }
}, [selectedClassId]);
const fetchYearsByClassId = async (classId) => {
  try {
    setLoadingYears(true);

    const res = await publicAxios.get(
      `${ApiKey.Year}/${classId}`
    );

    setYears(res.data || []);
  } catch (err) {
    console.error("Failed to fetch years", err);
    setYears([]);
  } finally {
    setLoadingYears(false);
  }
};
  const fetchCourses = async () => {
    try {
      setLoadingCourses(true);
      const res = await publicAxios.get(`${ApiKey.Class}`);
      setCourses(res.data || []);
    } catch (err) {
      console.error("Failed to fetch courses", err);
    } finally {
      setLoadingCourses(false);
    }
  };
  useEffect(() => {
    if (showEducationFields || editIndex !== null) {
      fetchCourses();
    }
  }, [showEducationFields, editIndex]);
  // Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.signup);

  // --- Validation regex ---
  const nameRegex = /^[A-Za-z ]{0,150}$/;
  // ✅ Updated email validation
  // Accepts typical company/college emails
  // Accept all standard valid email formats
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const initialRegex = /^[A-Za-z]{0,1}$/;

  const fatherOccupationRegex = /^[A-Za-z /-]{0,150}$/;

  const usernameRegex = /^[A-Za-z0-9_]{3,20}$/;
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/;
  const phoneRegex = /^[1-9]\d{9}$/;
  const courseRegex = /^[A-Za-z0-9.,(){}"':;/|\/\-\s]{0,150}$/;
  const collegeRegex = /^[A-Za-z0-9.,(){}"':;/|\/\-\s]{0,250}$/;
  const yearRegex = /^[A-Za-z0-9\s]{1,50}$/;
  const incomeRegex = /^(₹\s?|Rs\.?\s?)?[0-9,./-]+$/;

  const addressRegex = /^[A-Za-z0-9\s,./():\-\n]+$/;

  const anyText350 = /^.{0,350}$/;

  const isValidEmail = (email) => {
    email = email.trim();

    // Basic regex: no spaces, contains @, proper chars
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) return false;

    const [local, domain] = email.split("@");
    if (!local || !domain) return false;

    // Local part rules
    if (local.startsWith(".") || local.endsWith(".")) return false;
    if (local.includes("..")) return false;

    // Domain rules
    if (domain.startsWith(".") || domain.endsWith(".")) return false;
    if (domain.includes("..")) return false;

    const domainParts = domain.split(".");
    if (domainParts.length < 2) return false;

    // Last two domain parts cannot be same (reject domain.com.com)
    const lastIndex = domainParts.length - 1;
    if (domainParts[lastIndex] === domainParts[lastIndex - 1]) return false;

    // Each domain part must contain only letters, numbers, hyphen (no special chars)
    for (let part of domainParts) {
      if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;
      if (part.startsWith("-") || part.endsWith("-")) return false; // no hyphen at start/end
    }

    return true;
  };


  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);

  // Fetch countries
  const fetchCountries = async () => {
    try {
      setLoadingCountries(true);
      const res = await publicAxios.get(`${ApiKey.Country}`);
      setCountries(res.data || []);
    } catch (err) {
      console.error("Failed to fetch countries", err);
    } finally {
      setLoadingCountries(false);
    }
  };

  // Fetch states based on selected country
  const fetchStates = async () => {
    try {
      setLoadingStates(true);
      const res = await publicAxios.get(`${ApiKey.State}`);
      setStates(res.data || []);
    } catch (err) {
      console.error("Failed to fetch states", err);
    } finally {
      setLoadingStates(false);
    }
  };
  useEffect(() => {
    fetchCountries();
    fetchStates();// fetch countries on component mount
  }, []);

  useEffect(() => {
    debugger;
    if (!selectedClassId) return;

    const loadSpecialization = async () => {
      try {
        debugger;
        const res = await fetchCoursesByClassReq(selectedClassId);
        setSpecializationList(res.data || []);
      } catch (err) {
        console.error("Failed to load specialization");
        setSpecializationList([]);
      }
    };

    loadSpecialization();
  }, [selectedClassId]);
  const specializationOptions = specializationList.map(c => ({
    value: c.courseId,
    label: c.courseName
  }));

  // --- Validation per step ---
  const validateStep = () => {
    let stepErrors = {};

    if (step === 0) {
      // First Name
      if (!basicDetails.email) {
        stepErrors.email = "Email is required.";
      } else if (!isValidEmail(basicDetails.email)) {
        stepErrors.email = "Enter a valid email.";
      }
      if (!basicDetails.firstName) {
        stepErrors.firstName = "Candidate’s Full Name is required.";
      } else if (!nameRegex.test(basicDetails.firstName)) {
        stepErrors.firstName = "Only alphabets allowed (max 150).";
      }


      // Last Name
      if (!basicDetails.lastName) {
        stepErrors.lastName = "Candidate’s Inital is required.";
      } else if (!initialRegex.test(basicDetails.lastName)) {
        stepErrors.lastName = "Only alphabets allowed (max 150).";
      }


      if (!basicDetails.countryId) {
        stepErrors.country = "Country is required.";
      }

      // State
      if (!basicDetails.stateId) {
        stepErrors.state = "State is required.";
      }


      // Phone
      if (!basicDetails.phone) {
        stepErrors.phone = "Phone number is required.";
      } else if (basicDetails.phone.startsWith("0")) {
        stepErrors.phone = "Phone number cannot start with 0.";
      }
      else if (!phoneRegex.test(basicDetails.phone)) {
        stepErrors.phone = "Phone number must be 10 digits and contain only numbers.";
      }

      // Father Occupation (optional)
      if (basicDetails.fatherOccupation &&
        !fatherOccupationRegex.test(basicDetails.fatherOccupation)) {
        stepErrors.fatherOccupation = "Only alphabets allowed (max 150 characters).";
      }

      // Mother Occupation (optional)
      if (basicDetails.motherOccupation &&
        !nameRegex.test(basicDetails.motherOccupation)) {
        stepErrors.motherOccupation = "Only alphabets allowed (max 150 characters).";
      }

      // Parent Contact Number (optional)
      if (basicDetails.parentContactNumber) {
        if (basicDetails.parentContactNumber.startsWith("0")) {
          stepErrors.parentContactNumber = "Phone number cannot start with 0.";
        } else if (!phoneRegex.test(basicDetails.parentContactNumber)) {
          stepErrors.parentContactNumber = "Enter a valid 10-digit mobile number.";
        }
      }

      if (basicDetails.familyIncome) {
        if (basicDetails.familyIncome.length > 20) {
          stepErrors.familyIncome = "Family income cannot exceed 20 characters.";
        } else if (!incomeRegex.test(basicDetails.familyIncome)) {
          stepErrors.familyIncome =
            "Family income can include numbers, ₹, Rs, /, -, commas and dots.";
        }
      }
      // Address (optional)
      // Address (optional)
      if (basicDetails.address) {
        const trimmedAddress = basicDetails.address.trim();

        if (trimmedAddress.length > 250) {
          stepErrors.address = "Address cannot exceed 250 characters.";
        } else if (!addressRegex.test(trimmedAddress)) {
          stepErrors.address =
            "Address can include letters, numbers, space, (), / , . and - only.";
        }
      }
      // Date of Birth
      if (!basicDetails.dob) {
        stepErrors.dob = "Date of birth is required.";
      }
      // Date of Birth
      // Date of Birth
      if (!basicDetails.dob) {
        stepErrors.dob = "Date of birth is required.";
      } else {
        const dob = new Date(basicDetails.dob);
        const todayDate = new Date();

        if (dob > todayDate) {
          stepErrors.dob = "Date of birth cannot be in the future.";
        } else {
          let age = todayDate.getFullYear() - dob.getFullYear();
          const monthDiff = todayDate.getMonth() - dob.getMonth();
          const dayDiff = todayDate.getDate() - dob.getDate();

          // Adjust age if birthday not yet reached this year
          if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
          }

          if (age < 10) {
            stepErrors.dob = "Age must be at least 10 years.";
          } else if (age > 79) {
            stepErrors.dob = "Age cannot be more than 79 years.";
          }
        }
      }

      // Gender
      if (!basicDetails.gender) {
        stepErrors.gender = "Gender is required.";
      }
    }

    if (step === 1) {
      if (educationList.length === 0)
        stepErrors.education = "Add at least one education record.";
    }

    if (step === 2) {
      const username = verification.username.trim();
      if (!username) {
        stepErrors.username = "Email is required.";
      } else if (!isValidEmail(username)) {
        stepErrors.username = "Enter a valid email.";
      }




      // Password
      if (!verification.password) {
        stepErrors.password = "Password is required.";
      } else if (!passwordRegex.test(verification.password)) {
        stepErrors.password =
          "Password must be min 6 chars, include letters, numbers & special char.";
      }
    }

    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  // --- Step navigation ---
  const nextStep = () => {
    if (validateStep()) setStep(step + 1);
  };
  const prevStep = () => setStep(step - 1);

  const [selectedFiles, setSelectedFiles] = useState([]); // newly selected files
  const [filesList, setFilesList] = useState([]); // display names
  const [fileSelected, setFileSelected] = useState(false);
  const [newFileSelected, setNewFileSelected] = useState(false);
  const [existingDocFiles, setExistingDocFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0) return;

    setSelectedFiles(files);               // store File objects
    setFilesList(files.map(f => f.name));  // store names for display

    setBasicDetails({ ...basicDetails, documents: files }); // attach to basicDetails
    setFileSelected(true);
  };
  // Upload files function returns uploaded file names
  const uploadFiles = async (applicationId) => {
    if (selectedFiles.length < 1) return [];

    const formDataPayload = new FormData();
    selectedFiles.forEach((file) => formDataPayload.append("FormFiles", file));
    formDataPayload.append("TypeofUser", "student");
    formDataPayload.append("id", applicationId);

    try {
      await uploadFormFilesReq(formDataPayload);

      // Return names of uploaded files for merging
      return selectedFiles.map(f => f.name);
    } catch (ex) {
      console.error("File upload failed:", ex);
      return [];
    }
  };
  const handleRemoveSingleFile = (index) => {

    const updatedFiles = existingDocFiles.filter((_, i) => i !== index);
    //setExistingDocFiles(updatedFiles);
    setFilesList(updatedFiles);

    /*setFormData(prev => ({
      ...prev,
      files: updatedFiles,
      fileName: updatedFiles.length > 0 ? updatedFiles.join("|") : "",
    }));*/
    // flags
    if (updatedFiles.length === 0) {
      setFileSelected(false);
      setNewFileSelected(false);
    }

    // clear input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

  };
  const handleClear = () => {
    setSelectedFiles([]);
    setFilesList([]);
    setFileSelected(false);
    setBasicDetails({ ...basicDetails, documents: [] }); // clear documents
    if (fileInputRef.current) fileInputRef.current.value = null;
  };

  // --- Save (Signup dispatch) ---
  const handleSave = async () => {
    if (!validateStep()) return;
    const createdBy = `${basicDetails.firstName} ${basicDetails.lastName}`.trim();
    const payload = {
      FirstName: basicDetails.firstName,
      LastName: basicDetails.lastName,
      Email: basicDetails.email,            // ✅ correct field
      Phone: basicDetails.phone,
      DateofBirth: basicDetails.dob,        // ✅ rename
      Gender: basicDetails.gender,
      UserName: verification.username,      // ✅ rename
      PasswordHash: verification.password,  // ✅ raw password
      RoleId: "1",
      Education: JSON.stringify(educationList),// ✅ backend expects string
      FatherOccupation: basicDetails.fatherOccupation,
      MotherOccupation: basicDetails.motherOccupation,
      Address: basicDetails.address,
      FamilyIncome: basicDetails.familyIncome,
      StateId: basicDetails.stateId,
      countryId: basicDetails.countryId,
      ParentsContactNumber: basicDetails.parentContactNumber,
      CreatedBy: createdBy,
    };


    // 1️⃣ Insert user and get ID
    const userId = await dispatch(insertNewUser(payload));
    if (!userId) return; // stop if insertion failed

    // 2️⃣ Upload documents if any
    if (basicDetails.documents && basicDetails.documents.length > 0) {
      try {
        await uploadFiles(userId);
      } catch (err) {
        console.error("File upload failed:", err);
        Swal.fire({
          text: "Documents upload failed!",
          icon: "error",
        });
        return;
      }
    }

    // 3️⃣ Show success alert after everything
    await Swal.fire({
      text: "Signup successful!",
      icon: "success",
      confirmButtonText: "OK",
    });

    // 4️⃣ Navigate to login
    navigate("/login");
  };

  // --- Education handlers ---
  const addEducation = () => {
    let errorsObj = {};
    // Degree / Course required
    if (!education.degree.trim()) {
      errorsObj.degree = "Course / Class is required.";
    }

    // REQUIRED validation
    if (!education.specification.trim()) {
      errorsObj.specification = "Discipline / Specialization is required.";
    } else if (!courseRegex.test(education.specification)) {
      errorsObj.specification = "Invalid Discipline / Specialization";
    }

    if (!education.college.trim()) {
      errorsObj.college = "School / College / University Name is required.";
    } else if (!collegeRegex.test(education.college)) {
      errorsObj.college = "Invalid School / College / University.";
    }

   if (shouldShowYear && !education.year.trim()) {
  errorsObj.year = "Year of Study required.";
}

    if (Object.keys(errorsObj).length > 0) {
      setEduErrors(errorsObj);
      return;
    }

    setEducationList([...educationList, education]);
    setEducation({ degree: "", specification: "", college: "", year: "" });
    setShowEducationFields(false);
    setEduErrors({});
  };


  const updateEducation = (index) => {
    let errorsObj = {};

    // Degree
    if (!education.degree.trim()) {
      errorsObj.degree = "Course / Class is required.";
    } else if (!courseRegex.test(education.degree)) {
      errorsObj.degree = "Invalid course.";
    }

    // Specification
    if (!education.specification.trim()) {
      errorsObj.specification = "Discipline / Specialization is required.";
    } else if (!courseRegex.test(education.specification)) {
      errorsObj.specification = "Invalid Discipline / Specialization.";
    }

    // College
    if (!education.college.trim()) {
      errorsObj.college = "College/University is required.";
    } else if (!collegeRegex.test(education.college)) {
      errorsObj.college = "Invalid college/university.";
    }

    // Year
    if (shouldShowYear && !education.year.trim()) {
  errorsObj.year = "Year of Study required.";
}

    if (Object.keys(errorsObj).length > 0) {
      setEduErrors(errorsObj);
      return;
    }

    const updated = [...educationList];
    updated[index] = education;
    setEducationList(updated);
    setEditIndex(null);
    setEducation({ degree: "", specification: "", college: "", year: "" });
    setEduErrors({});
  };


  const deleteEducation = (index) => {
    const updated = educationList.filter((_, i) => i !== index);
    setEducationList(updated);
  };

  // --- DOB restrictions ---
  const today = new Date().toISOString().split("T")[0];
  const minDob = new Date();
  minDob.setFullYear(minDob.getFullYear() - 79);
  const minDobStr = minDob.toISOString().split("T")[0];

  const isStepCompleted = (stepIndex) => {
    if (stepIndex === 0) {
      return (
        basicDetails.firstName &&
        nameRegex.test(basicDetails.firstName) &&
        basicDetails.lastName &&
        initialRegex.test(basicDetails.lastName) &&
        basicDetails.email &&
        isValidEmail(basicDetails.email) &&
        basicDetails.phone &&
        phoneRegex.test(basicDetails.phone) &&
        basicDetails.dob &&
        basicDetails.gender
      );
    }
    if (stepIndex === 1) return educationList.length > 0;
    return true;
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        {/* Header */}
        <div className="signup-header">
          <h2>Student Sign Up</h2>
          <p>
            Already a member?{" "}
            <Link to={RP.login} state={{ userType }} className="signup-link">
              Sign In
            </Link>
          </p>
        </div>

        {/* Step navigation */}
        <div className="signup-steps">
          {["Basic Details", "Education", "Verification"].map((label, i) => (
            <div key={i} className="step-item">
              <div
                className={`step-circle ${i === step ? "active" : ""} ${i > 0 && !isStepCompleted(i - 1) ? "disabled" : ""
                  }`}
                onClick={() => {
                  if (i === 0 || isStepCompleted(i - 1)) setStep(i);
                }}
                title={label}
              >
                {i + 1}
              </div>
              <span className="step-label">{label}</span>
            </div>
          ))}
        </div>

        {/* Error / Loading messages */}
        {loading && <p className="loading-text">Processing...</p>}
        {/* {error && <p className="error-text">Something went wrong, try again!</p>} */}

        {/* Step Content */}
        {/* Step 0: Basic Details */}
        {step === 0 && (
          <div>
            {/*  <h3 className="section-title">Basic Details</h3> */}
            <h3 className="sponsor-section-title">Basic Details</h3>


            <div className="row">
              <div className="form-group" >
                <label>Candidate’s Full Name *</label>
                <input
                  type="text"
                  value={basicDetails.firstName}
                  onChange={(e) =>
                    nameRegex.test(e.target.value) &&
                    setBasicDetails({ ...basicDetails, firstName: e.target.value })
                  }
                  className={errors.firstName ? "input-error" : ""}
                  placeholder="Candidate’s Full Name"
                />
                {errors.firstName && <p className="error-text">{errors.firstName}</p>}
              </div>
              <div className="form-group">
                <label>Candidate’s Initial *</label>
                <input
                  type="text"
                  value={basicDetails.lastName}
                  onChange={(e) =>
                    initialRegex.test(e.target.value) &&
                    setBasicDetails({ ...basicDetails, lastName: e.target.value })
                  }
                  className={errors.lastName ? "input-error" : ""}
                  placeholder="Candidate’s Initial"
                //maxLength={1}
                />
                {errors.lastName && <p className="error-text">{errors.lastName}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Email Address *</label>
                <input
                  type="text" // can stay email or text
                  value={basicDetails.email}
                  onChange={(e) => setBasicDetails({ ...basicDetails, email: e.target.value })}
                  className={errors.email ? "input-error" : ""}
                  placeholder="Email Address"
                />



                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>
              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  type="text"
                  maxLength={10}
                  value={basicDetails.phone}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only numbers while typing
                    if (/^\d*$/.test(value)) {
                      setBasicDetails({ ...basicDetails, phone: value });
                    }
                  }}
                  className={errors.phone ? "input-error" : ""}
                  placeholder="Phone Number"
                />
                {errors.phone && <p className="error-text">{errors.phone}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Date of Birth *</label>
                <input
                  type="date"
                  value={basicDetails.dob}
                  max={today}
                  min={minDobStr}
                  onChange={(e) => setBasicDetails({ ...basicDetails, dob: e.target.value })}
                  className={errors.dob ? "input-error" : ""}
                />
                {errors.dob && <p className="error-text">{errors.dob}</p>}
              </div>
              <div className="form-group">
                <label>Gender *</label>
                <div className="gender-group">
                  <label>   Male
                  </label>
                  <input
                    type="radio"
                    name="gender"
                    checked={basicDetails.gender === "Male"}
                    onChange={() => setBasicDetails({ ...basicDetails, gender: "Male" })}
                  />

                  <label>  Female
                  </label>
                  <input
                    type="radio"
                    name="gender"
                    checked={basicDetails.gender === "Female"}
                    onChange={() => setBasicDetails({ ...basicDetails, gender: "Female" })}
                  />

                </div>
                {errors.gender && <p className="error-text">{errors.gender}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Father's Name </label>
                <input
                  type="text"
                  value={basicDetails.motherOccupation}
                  onChange={(e) =>
                    nameRegex.test(e.target.value) &&
                    setBasicDetails({ ...basicDetails, motherOccupation: e.target.value })
                  }
                  className={errors.motherOccupation ? "input-error" : ""}
                  placeholder="Enter name of father"
                />
                {errors.motherOccupation && <p className="error-text">{errors.motherOccupation}</p>}
              </div>
              <div className="form-group" >
                <label>Occupation of Father</label>
                <input
                  type="text"
                  value={basicDetails.fatherOccupation}
                  onChange={(e) =>
                    fatherOccupationRegex.test(e.target.value) &&
                    setBasicDetails({ ...basicDetails, fatherOccupation: e.target.value })
                  }
                  className={errors.fatherOccupation ? "input-error" : ""}
                  placeholder="Father Occupation"
                />
                {errors.fatherOccupation && <p className="error-text">{errors.fatherOccupation}</p>}
              </div>

            </div>
            <div className="row">
              <div className="form-group">
                <label>Parent's Phone Number </label>
                <input
                  type="text"
                  maxLength={10}
                  value={basicDetails.parentContactNumber}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only numbers while typing
                    if (/^\d*$/.test(value)) {
                      setBasicDetails({ ...basicDetails, parentContactNumber: value });
                    }
                  }}
                  className={errors.parentContactNumber ? "input-error" : ""}
                  placeholder="Parent's Phone Number"
                />
                {errors.parentContactNumber && <p className="error-text">{errors.parentContactNumber}</p>}
              </div>
              <div className="form-group">
                <label>Annual Family Income</label>
                <input
                  type="text"
                  value={basicDetails.familyIncome}
                  onChange={(e) =>

                    setBasicDetails({ ...basicDetails, familyIncome: e.target.value })
                  }
                  className={errors.familyIncome ? "input-error" : ""}
                  placeholder="Annual Family Income"
                  maxLength={20}
                />
                {errors.familyIncome && <p className="error-text">{errors.familyIncome}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Country <span className="required">*</span></label>
                <select
                  value={basicDetails.countryId}
                  onChange={(e) => setBasicDetails({ ...basicDetails, countryId: e.target.value, state: "" })}
                  className={errors.country ? "input-error" : ""}
                >
                  <option value="">Select Country</option>
                  {countries.map((c) => (
                    <option key={c.id} value={c.id}>{c.country_Name}</option>
                  ))}
                </select>
                {errors.country && <p className="error-text">{errors.country}</p>}
              </div>

              <div className="form-group">
                <label>State <span className="required">*</span></label>
                <select
                  value={basicDetails.stateId}
                  onChange={(e) => setBasicDetails({ ...basicDetails, stateId: e.target.value })}
                  className={errors.state ? "input-error" : ""}

                >
                  <option value="">Select State</option>
                  {states.map((s) => (
                    <option key={s.id} value={s.id}>{s.state_Name}</option>
                  ))}
                </select>
                {errors.state && <p className="error-text">{errors.state}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Address </label>
                <textarea
                  value={basicDetails.address}
                  maxLength={250}
                  rows={4}
                  placeholder="Address"
                  className={errors.address ? "input-error" : ""}
                  onChange={(e) => {
                    setBasicDetails({
                      ...basicDetails,
                      address: e.target.value
                    });
                  }}
                />

                {errors.address && <p className="error-text">{errors.address}</p>}
              </div>
            </div>

            <div className="form-group col-12">
              <label>Upload Profile Photo</label>
              <input
                type="file"
                accept="image/*"
                name="documents"
                onChange={handleFileChange}
                // multiple
                ref={fileInputRef}
              // disabled={isViewMode}
              />

              {fileSelected && filesList.length > 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger mt-2"
                  onClick={handleClear}
                  style={{ marginTop: "10px" }}
                >
                  Clear
                </button>
              )}

              {filesList.length > 0 && (
                <div className="d-flex flex-column mt-2 rounded" style={{ marginTop: "5px" }}>
                  {filesList.map((fileName, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center justify-content-between border rounded p-2 mb-1"
                      style={{
                        gap: "12px",
                        paddingLeft: "14px",
                        paddingRight: "12px",
                        color: "black"
                      }}
                    >
                      <span>{fileName}</span>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleRemoveSingleFile(index)}
                        style={{ marginLeft: "5px" }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}



            </div>


          </div>
        )}

        {/* Education Step */}
        {step === 1 && (
          <div>
            <div className="education-header">
              <h3>Current Education Details</h3>
              {!showEducationFields && editIndex === null && (
                <button onClick={() => setShowEducationFields(true)} className="add-btn">
                  + Add Education
                </button>
              )}
            </div>

            {errors.education && <p className="error-text">{errors.education}</p>}

            {/*{educationList.length > 0 && (
              <div className="education-grid header">
                <div>Course</div>
                <div>College / University</div>
                <div>Year</div>
                <div>Actions</div>
              </div>
            )}
*/}
            {educationList.map((edu, index) =>
              editIndex === index ? (
                <div className="education-grid" key={index}>

                  <div className="form-group">
                    <label>Class/Course <span className="required">*</span></label>
                    {/*<select
                      value={education.degree}
                      onChange={(e) =>
                        setEducation({ ...education, degree: e.target.value })
                      }
                      className={eduErrors.degree ? "input-error" : ""}
                    >
                      <option value="">Select Course</option>

                      {courses.map((course) => (
                        <option key={course.classId} value={course.className}>
                          {course.className}
                        </option>
                      ))}
                    </select>*/}
                    <select
                      value={education.degree}
                      onChange={(e) => {
                        const value = e.target.value;

                        setEducation({
                          ...education,
                          degree: value,
                          specification: "",
                          year:""
                        });

                        const selected = courses.find(c => c.className === value);

                        if (selected) {
                          setSelectedClassId(selected.classId);
                           fetchYearsByClassId(selected.classId);
                        }
                        else{
                          setYears([]);
                        }
                      }}
                    >
                      <option value="">Select Class / Course</option>
                      {courses.map(course => (
                        <option key={course.classId} value={course.className}>
                          {course.className}
                        </option>
                      ))}
                    </select>

                    {eduErrors.degree && (
                      <p className="error-text">{eduErrors.degree}</p>
                    )}

                  </div>
                  <div className="form-group">
                    <label>Discipline / Specialization <span className="required">*</span></label>
                    {/*<input
                      type="text"
                      placeholder="Specialization"
                      value={education.specification}
                      onChange={(e) => setEducation({ ...education, specification: e.target.value })}
                           className={eduErrors.specification ? "input-error" : ""}
                    />*/}
                    <CreatableSelect
                      options={specializationOptions}
                      placeholder="Select or type discipline / specialization"
                      value={
                        specializationOptions.find(
                          opt => opt.label === education.specification
                        ) || (
                          education.specification
                            ? { label: education.specification, value: education.specification }
                            : null
                        )
                      }
                      onChange={(selected) => {
                        if (!selected) {
                          setEducation(prev => ({
                            ...prev,
                            specification: ""
                          }));
                          return;
                        }

                        setEducation(prev => ({
                          ...prev,
                          specification: selected.label
                        }));
                      }}
                      onCreateOption={(inputValue) => {
                        setEducation(prev => ({
                          ...prev,
                          specification: inputValue
                        }));
                      }}
                      isClearable
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "6px",
                          minHeight: "44px"
                        }),
                        input: (base) => ({
                          ...base,
                          boxShadow: "none"
                        })
                      }}
                    />


                    {eduErrors.specification && (
                      <p className="error-text">{eduErrors.specification}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label>School / College / University Name <span className="required">*</span></label>
                    <input
                      type="text"
                      placeholder="School / College / University Name"
                      value={education.college}
                      onChange={(e) => setEducation({ ...education, college: e.target.value })}
                      className={eduErrors.college ? "input-error" : ""}
                    />
                    {eduErrors.college && (
                      <p className="error-text">{eduErrors.college}</p>
                    )}
                  </div>
{shouldShowYear && (
                  <div className="form-group">
                    <label>Year of Study<span className="required">*</span></label>
                    <select
  value={education.year}
  onChange={(e) =>
    setEducation({ ...education, year: e.target.value })
  }
  className={eduErrors.year ? "input-error" : ""}
  disabled={!education.degree}
>
  {/*<option value="">
    {loadingYears ? "Loading..." : "Select Year"}
  </option>*/}
   <option value="">Select Year</option>

  {years.map((item, index) => (
    <option key={index} value={item.year}>
      {item.year}
    </option>
  ))}
</select>

                    {eduErrors.year && (
                      <p className="error-text">{eduErrors.year}</p>
                    )}
                  </div>
)}
                  <div className="sign-action-btns">
                    <button onClick={() => updateEducation(index)} className="sign-action-btn">Save</button>
                    <button onClick={() => {
                      setEditIndex(null);
                      setEducation({ degree: "", college: "", year: "" });
                    }} className="sign-action-btn">Cancel</button>
                  </div>
                </div>
              ) : (
                <div className="education-grid" key={index}>

                  <div className="label-value">
                    <span className="label">Class / Course</span>
                    <span className="value">{edu.degree}</span>
                  </div>
                  <div className="label-value">
                    <span className="label">Discipline / Specialization</span>
                    <span className="value">{edu.specification}</span>
                  </div>

                  <div className="label-value">
                    <span className="label">School / College / University Name</span>
                    <span className="value">{edu.college}</span>
                  </div>
{shouldShowYear && (
                  <div className="label-value">
                    <span className="label">Year of Study</span>
                    <span className="value">{edu.year}</span>
                  </div>
)}
                  <div className="sign-action-btns">
                    <button
                      onClick={() => {

                        const selected = courses.find(
                          c => c.className === edu.degree
                        );

                        if (selected) {
                          setSelectedClassId(selected.classId);
                        }

                        setEditIndex(index);
                        setEducation(edu);
                        setShowEducationFields(false);
                      }}
                      className="sign-action-btn"
                    >
                      Edit
                    </button>
                    <button onClick={() => deleteEducation(index)} className="sign-action-btn">
                      Delete
                    </button>
                  </div>

                </div>

              )
            )}


            {showEducationFields && editIndex === null && (
              <div className="education-grid">

                <div className="form-group">
                  <label>Class / Course *</label>

                  <select
                    value={education.degree}
                    onChange={(e) => {
                      const value = e.target.value;

                      setEducation({
                        ...education,
                        degree: value,
                        specification: "",
                         year:""
                      });

                      const selected = courses.find(c => c.className === value);

                      if (selected) {
                        setSelectedClassId(selected.classId);
                       fetchYearsByClassId(selected.classId);
                        }
                        else{
                          setYears([]);
                        }
                    }}
                    className={eduErrors.degree ? "input-error" : ""}
                  >
                    <option value="">Select Class / Course</option>
                    {courses.map((course) => (
                      <option key={course.classId} value={course.className}>
                        {course.className}
                      </option>
                    ))}
                  </select>

                  {eduErrors.degree && (
                    <p className="error-text">{eduErrors.degree}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>Discipline / Specialization *</label>
                  {/* <input
                    type="text"
                    placeholder="Specialization"
                    value={education.specification}
                    maxLength={150}
                    onChange={(e) =>
                      courseRegex.test(e.target.value) &&
                      setEducation({ ...education, specification: e.target.value })
                    }
                    className={eduErrors.specification ? "input-error" : ""}
                  />*/} <CreatableSelect
                    options={specializationOptions}
                    placeholder="Select or type discipline / specialization"
                    value={
                      specializationOptions.find(
                        opt => opt.label === education.specification
                      ) || (
                        education.specification
                          ? { label: education.specification, value: education.specification }
                          : null
                      )
                    }
                    onChange={(selected) => {
                      if (!selected) {
                        setEducation(prev => ({
                          ...prev,
                          specification: ""
                        }));
                        return;
                      }

                      setEducation(prev => ({
                        ...prev,
                        specification: selected.label
                      }));
                    }}
                    onCreateOption={(inputValue) => {
                      setEducation(prev => ({
                        ...prev,
                        specification: inputValue
                      }));
                    }}
                    isClearable

                  />
                  {eduErrors.specification && <p className="error-text">{eduErrors.specification}</p>}
                </div>

                <div className="form-group">
                  <label>School / College / University Name *</label>
                  <input
                    type="text"
                    placeholder="School / College / University Name"
                    value={education.college}
                    maxLength={250}
                    onChange={(e) =>
                      collegeRegex.test(e.target.value) &&
                      setEducation({ ...education, college: e.target.value })
                    }
                    className={eduErrors.college ? "input-error" : ""}
                  />
                  {eduErrors.college && <p className="error-text">{eduErrors.college}</p>}
                </div>

{shouldShowYear && (
                <div className="form-group">
                  <label>Year of Study *</label>
                   <select
  value={education.year}
  onChange={(e) =>
    setEducation({ ...education, year: e.target.value })
  }
  className={eduErrors.year ? "input-error" : ""}
  disabled={!education.degree}
>
  {/*<option value="">
    {loadingYears ? "Loading..." : "Select Year"}
  </option>*/}
   <option value="">Select Year</option>

  {years.map((item, index) => (
    <option key={index} value={item.year}>
      {item.year}
    </option>
  ))}
</select>

                  {eduErrors.year && <p className="error-text">{eduErrors.year}</p>}
                </div>)}


                <div className="sign-action-btns">
                  <button onClick={addEducation} className="sign-action-btn">
                    Save
                  </button>
                  <button
                    onClick={() => {
                      setShowEducationFields(false);
                      setEducation({ degree: "", college: "", year: "" });
                      setEduErrors({}); // 🔹 clear errors on Cancel
                    }}
                    className="sign-action-btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
            {/* Show errors only after clicking Save */}

          </div>
        )}

        {/* Step 2: Verification */}
        {step === 2 && (
          <div >
            <div className="verfiy">
              <h3>Verification</h3>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="text"
                  placeholder="Enter your email"
                  value={verification.username}
                  onChange={(e) =>
                    setVerification({ ...verification, username: e.target.value.trim() })
                  }
                  className={errors.username ? "input-error" : ""}
                />





                {errors.username && <p className="error-text">{errors.username}</p>}

              </div>
              <div className="form-group">
                <label>
                  Password<span className="hint">(Must be min 6 chars, include letters, numbers & special char)</span> *
                </label>


                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={verification.password}
                    onChange={(e) =>
                      setVerification({ ...verification, password: e.target.value })
                    }
                    className={errors.password ? "input-error" : ""}
                  />

                  <span
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </span>
                </div>

                {errors.password && <p className="error-text">{errors.password}</p>}
              </div>

            </div>
          </div>
        )}

        {/* Navigation buttons */}
        <div className="nav-buttons">
          {step > 0 && (
            <button onClick={prevStep} className="nav-btn">
              Previous
            </button>
          )}
          {step < 2 && (
            <button onClick={nextStep} className="nav-btn">
              Next
            </button>
          )}
          {step === 2 && (
            <button onClick={handleSave} className="save-btn" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
